export default __webpack_public_path__ + "static/media/play.89cf933f.svg";